import React, { useState, useCallback, useEffect } from "react";
import { Button, Layout, Modal, TextArea } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
export var NoteInputModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, onSubmit = _a.onSubmit, labelId = _a.labelId, submitLabelId = _a.submitLabelId, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, _c = _a.noteRequired, noteRequired = _c === void 0 ? true : _c;
    var formatMessage = useIntl().formatMessage;
    var _d = useState(""), noteText = _d[0], setNoteText = _d[1];
    useEffect(function () {
        if (!open)
            setNoteText("");
    }, [open]);
    var handleClose = useCallback(function () {
        setNoteText("");
        onClose();
    }, [onClose]);
    var handleSubmit = useCallback(function () {
        onSubmit(noteText.trim());
    }, [noteText, onSubmit]);
    return (React.createElement(Modal, { open: open, label: formatMessage({ id: labelId }), onClose: handleClose, size: "small", footer: React.createElement(Layout, { className: "display-flex justify-end" },
            React.createElement(Button, { onClick: handleClose },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.cancel" })),
            React.createElement(Button, { buttonStyle: "primary", disabled: (noteRequired && !noteText.trim()) || isLoading, onClick: handleSubmit },
                React.createElement(FormattedMessage, { id: submitLabelId }))) },
        React.createElement(TextArea, { label: formatMessage({
                id: "ui-br-legaldeposits.investigation.note.label",
            }), value: noteText, onChange: function (e) {
                return setNoteText(e.target.value);
            }, required: noteRequired })));
};
